module.exports = __webpack_public_path__ + "static/media/icon-galaxy.3eacfb8c.svg";